<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <roles-crud></roles-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RolesCrud from './roles/RolesCrud';

    export default {

        components: {
            RolesCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.roles'),
                    },
                ]
            }
        },
    }
</script>
